import { voteImage, approveImage } from './data.js'

export function trackEvent(data) {
  if (window.ga !== undefined) {
    let tracker = window.ga.getAll()[0]
    tracker.send('event', data.type, data.ev, data.val)
  }
}

export function voteForContent(el, id, vote) {

  let buttons = document.querySelectorAll(`[data-id='${id}']`)
  buttons.forEach((button) => {
    button.classList.remove('is-clicked')
  })
  el.target.classList.add('is-clicked')

  voteImage(id, vote)
  trackEvent({ type: 'vote', ev: vote, val: id })
}


export function popAdminData(data) {

  const dataHolder = document.querySelector('.data-holder')

  data.sort((a, b) => { return a.date > b.date ? 1 : -1 })

  dataHolder.innerHTML = ''
  data.forEach((item) => {

    let owner = (item.owner === undefined) ? '' : `credit: ${item.owner}`
    let approved = item.approved === true ? 'checked' : ''
    let date = new Date(item.date).toLocaleDateString("en-UK")
    let percent = Math.floor((item.voteCount / item.totalVotes * 100))

    let imageWrapper = `<tr data-id="${item.pID}">
                          <td class="img-holder" style="background-image: url(${item.assetURL})"><a href="${item.assetURL}" target="_blank">+</a></td>
                          <td>${owner}</td>
                          <td><label for="${item.pID}">visible?</label><input class="toggle-approved" type="checkbox" name="approved" id="${item.pID}" ${approved} /></td>
                          <td>date: ${date}</td>
                          <td>liked: ${percent}%</td>
                        </tr>`
    dataHolder.insertAdjacentHTML('afterbegin', imageWrapper)
  })

  let toggleApporved = document.querySelectorAll('.toggle-approved')
  toggleApporved.forEach((toggle) => {
    bindToggleListener(toggle)
  })

}

export function bindToggleListener(toggle) {
  toggle.addEventListener('change', (e) => {
    approveImage(e.target.id, e.target.checked)
  })
}

export function addMenu(el) {

  if (!el) {
    return
  }

  const overlay = document.querySelector('.overlay-content')

  el.addEventListener('click', () => {
    el.classList.toggle('is-active')
    overlay.classList.toggle('is-visible')

    // Toggle aria-expanded attribute value when the overlay is shown/hidden.
    const ariaState = el.getAttribute("aria-expanded");
    const newAriaState = ariaState == "true" ? "false" : "true";
    el.setAttribute("aria-expanded", newAriaState);
  })
}



// WEBPACK FOOTER //
// ./js/utils.js